import { useAuth } from 'App/context/AuthContext';

export const useToken = () => useAuth().token;
